import { QueryClient } from '@tanstack/react-query';
import { LoaderFunctionArgs, redirect } from 'react-router';
import { listMetricsQuery } from '~/shared/api/metrics.queries';
import { getSystemSimulationQuery } from '~/shared/api/simulations.queries';
import { checkAuthorization } from '~/shared/auth/auth-utils';
import { SensorReadingsData } from '~/shared/hooks/useLatestMetrics';
import { assertIsDefined } from '~/types/assert-type';

export const productInfoSidebarSectionInSimulationLoader =
  (queryClient: QueryClient) =>
  async ({
    params,
    request,
  }: LoaderFunctionArgs): Promise<SensorReadingsData | Response> => {
    await checkAuthorization(queryClient, request);
    const { productId, simulationId } = params;

    assertIsDefined(productId);
    assertIsDefined(simulationId);

    const simulation = await queryClient.ensureQueryData(
      getSystemSimulationQuery({ simulationId }),
    );

    const product = simulation.system?.productById(productId);

    if (!product) {
      return redirect('..');
    }

    const metrics = await queryClient.ensureQueryData(
      listMetricsQuery({
        targets: product.availableMetricTargets,
        simulation,
      }),
    );

    return { metrics };
  };
